import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/CollectCharts/Get`, payload),
}
